"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateLicenseSchema = void 0;
const license_schema_1 = require("../core-model-schemas/license-schema");
const license_enums_1 = require("../enums/license-enums");
const zod_1 = require("zod");
exports.CreateLicenseSchema = zod_1.z.object({
    name: zod_1.z
        .string()
        .min(3, 'Name must be at least 3 characters')
        .max(100, 'Name must be at most 100 characters'),
    ipType: license_enums_1.IPTypeSchema,
    licenseeId: zod_1.z
        .string()
        .min(12, 'Licensee ID must be at least 12 characters'),
    patentId: zod_1.z
        .string()
        .min(12, 'Patent ID must be at least 12 characters')
        .nullish(),
    caseId: zod_1.z.string().min(12, 'Case ID must be at least 12 characters'),
    milestones: zod_1.z.array(license_schema_1.LicenseMilestoneSchema),
    startDate: zod_1.z.coerce.date().nullish(),
    terminationDate: zod_1.z.coerce.date().nullish(),
});
